import {
  __spreadProps,
  __spreadValues
} from "./chunk.K2NRSETB.js";

// src/utilities/responsive-value-utils.ts
var breakpointPixels = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
function defaultNameFormatter(prefix, key, name, breakpoint) {
  const classname = `${prefix}--${key}-${name}`;
  return breakpoint ? `${classname}-${breakpoint}` : classname;
}
function updateBreakpointClasses(element, key, options, oldValue, newValue, format = defaultNameFormatter) {
  const name = element.tagName.toLowerCase().replace("fadv-", "");
  if (oldValue) {
    element.classList.remove(...createBreakpointClasslist(name, key, oldValue, options, format));
  }
  if (newValue) {
    element.classList.add(...createBreakpointClasslist(name, key, newValue, options, format));
  }
}
function createBreakpointClasslist(prefix, key, value, options, format = defaultNameFormatter) {
  if (!value)
    return [];
  if (options.includes(value)) {
    return [format(prefix, key, `${value}`)];
  }
  const breakpoints = value;
  return Object.keys(breakpoints).reduce((results, breakpoint) => {
    const v = breakpoints[breakpoint];
    if (v !== null && v !== void 0) {
      results.push(format(prefix, key, `${v}`, breakpoint));
    }
    return results;
  }, []);
}
function createBreakpointClassInfo(element, key, values) {
  const name = element.tagName.toLowerCase().replace("fadv-", "");
  const value = element[key];
  if (value === null || value === void 0)
    return {};
  if (values.some((x) => x === value))
    return { [`${name}--${key}-${value}`]: true };
  const breakpoints = value;
  return Object.keys(breakpoints).reduce((result, breakpoint) => {
    const v = breakpoints[breakpoint];
    return v ? __spreadProps(__spreadValues({}, result), { [`${name}--${key}-${v}-${breakpoint}`]: true }) : result;
  }, {});
}
function getResponsive(prop, defaultValue, width = window.innerWidth) {
  let result;
  const { sm, md, lg, xl, xxl } = breakpointPixels;
  if (width < sm) {
    result = prop == null ? void 0 : prop.xs;
  } else if (width >= sm && width < md) {
    result = prop == null ? void 0 : prop.sm;
  } else if (width >= md && width < lg) {
    result = (prop == null ? void 0 : prop.md) || (prop == null ? void 0 : prop.sm);
  } else if (width >= lg && width < xl) {
    result = (prop == null ? void 0 : prop.lg) || (prop == null ? void 0 : prop.md) || (prop == null ? void 0 : prop.sm);
  } else if (width >= xl && width < xxl) {
    result = (prop == null ? void 0 : prop.xl) || (prop == null ? void 0 : prop.lg) || (prop == null ? void 0 : prop.md) || (prop == null ? void 0 : prop.sm);
  } else if (width >= xxl) {
    result = (prop == null ? void 0 : prop.xxl) || (prop == null ? void 0 : prop.xl) || (prop == null ? void 0 : prop.lg) || (prop == null ? void 0 : prop.md) || (prop == null ? void 0 : prop.sm);
  }
  return result || defaultValue;
}
function getResponsiveNumber(prop, defaultValue, width = window.innerWidth) {
  if (typeof prop === "number")
    return prop;
  return getResponsive(prop, defaultValue, width);
}
function getResponsiveValue(prop, values, defaultValue, width = window.innerWidth) {
  if (values.includes(prop))
    return prop;
  return getResponsive(prop, defaultValue, width);
}

export {
  breakpointPixels,
  updateBreakpointClasses,
  createBreakpointClasslist,
  createBreakpointClassInfo,
  getResponsiveNumber,
  getResponsiveValue
};
